import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ProjectsService } from "../services/projects/projects.service";
import { environment } from "../../environments/environment";

declare var Tafgeet: any;

@Component({
  selector: "app-print-cheque",
  templateUrl: "./print-cheque.component.html",
  styleUrls: ["./print-cheque.component.css"],
})
export class PrintChequeComponent implements OnInit {
  readonly DATE_FORMAT_STANDARD = 1;
  readonly DATE_FORMAT_SPACED_DDMMYYYY = 2;
  readonly DEFAULT_DATE_DIGIT_SPACING_PX = 1;
  readonly MAX_CHEQUE_WIDTH_CM = 30;
  readonly MAX_CHEQUE_HEIGHT_CM = 15;

  bank_image: any;
  name: string = null;
  date: any = "";
  dateFormat: number = this.DATE_FORMAT_STANDARD;
  dateDigitSpacingPx: number = this.DEFAULT_DATE_DIGIT_SPACING_PX;
  amount_text: any = "";
  amountAfterFormat: any = "";
  uploadLayoutForm: FormGroup;
  liner_text: any = "";
  amount: any;

  mode: "new" | "saved" = null;
  selectedTemplateId: number;
  templates: any[] = [];
  selectedTemplate: any;
  banks: any[] = [];
  developers: any[] = [];

  private requestedMode: "new" | "saved" | null = null;
  private requestedTemplateId: number | null = null;
  private hasAppliedRequestedState = false;

  lockModeSelection = false;
  lockTemplateSelection = false;
  chequeDimensions: { width: number; height: number } = {
    width: 17.5,
    height: 8.2,
  };

  currentPositions: any = {
    date: {
      left: "66px",
      top: "26px",
      width: "100px",
      right: "auto",
    },
    beneficiary_name: {
      left: "auto",
      top: "64px",
      right: "2.7cm",
      bottom: "auto",
    },
  };

  constructor(
    private formBuilder: FormBuilder,
    private slimLoadingBarService: SlimLoadingBarService,
    private projectsService: ProjectsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.createNewLayoutForm();
  }

  ngOnInit() {
    this.readRequestedStateFromQueryParams();
    this.date = this.getTodayDateForInput();
    this.getTemplates();
    this.getBanks();
    this.getDevelopers();
  }

  private readRequestedStateFromQueryParams() {
    const modeParam = String(
      this.route.snapshot.queryParamMap.get("mode") || ""
    )
      .trim()
      .toLowerCase();
    const templateIdParam = Number(
      this.route.snapshot.queryParamMap.get("templateId")
    );

    if (modeParam === "new" || modeParam === "saved") {
      this.requestedMode = modeParam as "new" | "saved";
      this.lockModeSelection = true;
    }

    if (!isNaN(templateIdParam) && templateIdParam > 0) {
      this.requestedTemplateId = templateIdParam;
      this.lockTemplateSelection = true;
      if (!this.requestedMode) {
        this.requestedMode = "saved";
      }
    }
  }

  getDevelopers() {
    this.projectsService.getDevelopers().subscribe((res: any) => {
      this.developers = Array.isArray(res) ? res : [];
    });
  }

  getBanks() {
    this.projectsService.getBanks().subscribe((res: any) => {
      this.banks = Array.isArray(res) ? res : res && res.data ? res.data : [];
      if (this.selectedTemplate) {
        this.patchBankSelectionFromTemplate(this.selectedTemplate);
      }
    });
  }

  onModeChange() {
    this.selectedTemplateId = null;
    this.selectedTemplate = null;
    this.bank_image = null;
    this.chequeDimensions = { width: 17.5, height: 8.2 };
    this.resetChequeViewFields();
    this.dateFormat = this.DATE_FORMAT_STANDARD;
    this.uploadLayoutForm.reset({
      template_name: "",
      bank_id: null,
      file: null,
      cheque_width: this.chequeDimensions.width,
      cheque_height: this.chequeDimensions.height,
    });
    setTimeout(() => this.handleDrag(), 200);
  }

  toEN(string = this.amount) {
    return String(string || "")
      .replace(/[\u0660-\u0669]/g, function (c) {
        return String(c.charCodeAt(0) - 0x0660);
      })
      .replace(/[\u06f0-\u06f9]/g, function (c) {
        return String(c.charCodeAt(0) - 0x06f0);
      });
  }

  updateAmount(val, cur) {
    val = this.toEN(val);
    if (parseFloat(val) > 0) {
      this.amountAfterFormat = "#" + this.formatMoney(parseFloat(val)) + "#";
      this.amount_text = new Tafgeet(val, cur).parse();
    }
  }

  createNewLayoutForm() {
    this.uploadLayoutForm = this.formBuilder.group({
      template_name: ["", [Validators.required, Validators.maxLength(255)]],
      bank_id: [null, Validators.required],
      file: [null],
      cheque_width: [
        this.chequeDimensions.width,
        [
          Validators.required,
          Validators.min(1),
          Validators.max(this.MAX_CHEQUE_WIDTH_CM),
        ],
      ],
      cheque_height: [
        this.chequeDimensions.height,
        [
          Validators.required,
          Validators.min(1),
          Validators.max(this.MAX_CHEQUE_HEIGHT_CM),
        ],
      ],
    });
  }

  handleUploadNewBank(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        const dataUrl = String(reader.result || "");
        const base64 = dataUrl.split(",")[1];
        const checkEl = document.getElementById("check");
        if (checkEl) {
          checkEl.style.backgroundImage = "url('data:image/png;base64," + base64 + "')";
        }
        this.bank_image = "data:image/png;base64," + base64;
        this.uploadLayoutForm.get("file").setValue({
          filename: file.name,
          filetype: file.type,
          value: base64,
        });
      };
    }
  }

  getTemplates() {
    this.slimLoadingBarService.start();
    this.projectsService.getBankCheques().subscribe(
      (res: any) => {
        const rows = Array.isArray(res) ? res : res && res.data ? res.data : [];
        this.templates = rows.map((template) => {
          template.display_name =
            template.template_name ||
            (template.bank && template.bank.name) ||
            template.bank_name ||
            ("Template #" + template.id);
          return template;
        });
        this.applyRequestedStateIfAny();
        this.slimLoadingBarService.complete();
      },
      () => this.slimLoadingBarService.reset()
    );
  }

  private applyRequestedStateIfAny() {
    if (this.hasAppliedRequestedState || !this.requestedMode) {
      return;
    }

    this.hasAppliedRequestedState = true;
    this.mode = this.requestedMode;
    this.onModeChange();

    if (this.requestedMode === "saved" && this.requestedTemplateId) {
      this.selectedTemplateId = this.requestedTemplateId;
      this.onSavedBankChange();
    }
  }

  saveBankCheuqe() {
    this.applyDimensionBoundsToForm();
    if (this.uploadLayoutForm.invalid) {
      Object.keys(this.uploadLayoutForm.controls).forEach((key) => {
        this.uploadLayoutForm.controls[key].markAsTouched();
      });
      return;
    }

    const payload = this.buildTemplatePayload();
    const isEdit = this.mode === "saved" && this.selectedTemplateId;

    this.slimLoadingBarService.start();
    const request$ = isEdit
      ? this.projectsService.updateBankCheque(this.selectedTemplateId, payload)
      : this.projectsService.addBankCheque(payload);

    request$.subscribe(
      () => {
        swal(
          "Success",
          isEdit
            ? "Template updated successfully"
            : "Template added successfully",
          "success"
        );
        this.slimLoadingBarService.complete();
        this.router.navigate(["/pages/bank-cheque-listing"]);
      },
      () => this.slimLoadingBarService.reset()
    );
  }

  onSavedBankChange() {
    if (!this.selectedTemplateId) {
      return;
    }

    this.slimLoadingBarService.start();
    this.projectsService.getBankChequeById(this.selectedTemplateId).subscribe(
      (res: any) => {
        this.selectedTemplate = res && res.data ? res.data : res;
        this.prepareBankCheque();
        this.slimLoadingBarService.complete();
      },
      () => this.slimLoadingBarService.reset()
    );
  }

  prepareBankCheque() {
    const template = this.selectedTemplate;
    const variables = template && template.variables ? template.variables : {};

    this.bank_image = this.resolveTemplateImageUrl(template);
    this.amount = this.valueOrNoData(
      variables && variables.amount ? variables.amount.value : null
    );
    this.date = this.normalizeDateForInput(
      variables && variables.date
        ? variables.date.raw_value || variables.date.value
        : null
    );

    const loadedFormat = Number(
      (variables && variables.date ? variables.date.format : null) ||
        (template ? template.date_format : null)
    );
    this.dateFormat =
      loadedFormat === this.DATE_FORMAT_SPACED_DDMMYYYY
        ? this.DATE_FORMAT_SPACED_DDMMYYYY
        : this.DATE_FORMAT_STANDARD;

    const rawDateSpacing =
      variables &&
      variables.date &&
      (variables.date.digit_spacing ||
        variables.date.digitSpacing ||
        variables.date.spacing ||
        variables.date.space ||
        variables.date.letter_spacing ||
        variables.date.letterSpacing)
        ? variables.date.digit_spacing ||
          variables.date.digitSpacing ||
          variables.date.spacing ||
          variables.date.space ||
          variables.date.letter_spacing ||
          variables.date.letterSpacing
        : template
        ? template.date_digit_spacing || template.dateDigitSpacing
        : null;

    this.dateDigitSpacingPx = this.normalizeDateDigitSpacing(
      rawDateSpacing,
      this.DEFAULT_DATE_DIGIT_SPACING_PX
    );

    this.amountAfterFormat = this.valueOrNoData(
      variables && variables.amount_text
        ? variables.amount_text.amountAfterFormat
        : null
    );
    this.name = this.valueOrNoData(
      variables && variables.beneficiary_name
        ? variables.beneficiary_name.value
        : null
    );
    this.amount_text = this.valueOrNoData(
      variables && variables.amount_text ? variables.amount_text.value : null
    );
    this.liner_text = String(
      variables && variables.linear ? variables.linear.value || "" : ""
    ).trim();

    this.uploadLayoutForm.patchValue({
      template_name: this.valueOrNoData(
        template ? template.template_name : null,
        "No Name"
      ),
      bank_id: null,
      file: null,
      cheque_width: this.chequeDimensions.width,
      cheque_height: this.chequeDimensions.height,
    });

    this.applyTemplateDimensions(template);
    this.patchBankSelectionFromTemplate(template);
    this.handleDrag(variables);
  }

  private resolveTemplateImageUrl(template: any): string {
    if (template && template.full_url) {
      return this.normalizeImageUrl(template.full_url);
    }

    const relativeUrl = String(
      template && template.url ? template.url : ""
    ).trim();
    if (!relativeUrl) {
      return null;
    }

    const normalizedBase = String(environment.api_raw_base_url || "").replace(
      /\/+$/,
      ""
    );
    const normalizedPath = relativeUrl.startsWith("/")
      ? relativeUrl
      : "/" + relativeUrl;
    return this.normalizeImageUrl(normalizedBase + normalizedPath);
  }

  private normalizeImageUrl(url: string): string {
    try {
      return encodeURI(String(url || "").trim());
    } catch (_e) {
      return String(url || "").trim();
    }
  }

  private applyTemplateDimensions(template: any) {
    const variables = template && template.variables ? template.variables : {};
    const raw =
      (variables && (variables.Dimensions || variables.dimensions)) ||
      (template && (template.Dimensions || template.dimensions)) ||
      {};

    const width =
      this.normalizeDimension(raw.width, this.MAX_CHEQUE_WIDTH_CM) ||
      this.normalizeDimension(raw.witdh, this.MAX_CHEQUE_WIDTH_CM) ||
      this.normalizeDimension(
        template ? template.width : null,
        this.MAX_CHEQUE_WIDTH_CM
      );

    const height =
      this.normalizeDimension(raw.height, this.MAX_CHEQUE_HEIGHT_CM) ||
      this.normalizeDimension(raw.higth, this.MAX_CHEQUE_HEIGHT_CM) ||
      this.normalizeDimension(
        template ? template.height : null,
        this.MAX_CHEQUE_HEIGHT_CM
      );

    if (width && height) {
      this.chequeDimensions = { width: width, height: height };
      this.uploadLayoutForm.patchValue(
        {
          cheque_width: width,
          cheque_height: height,
        },
        { emitEvent: false }
      );
    }
  }

  onChequeDimensionsChange() {
    const width = this.normalizeDimension(
      this.uploadLayoutForm.get("cheque_width").value,
      this.MAX_CHEQUE_WIDTH_CM
    );
    const height = this.normalizeDimension(
      this.uploadLayoutForm.get("cheque_height").value,
      this.MAX_CHEQUE_HEIGHT_CM
    );

    if (width && height) {
      this.chequeDimensions = { width: width, height: height };
    }
  }

  onChequeDimensionsBlur() {
    this.applyDimensionBoundsToForm();
  }

  private applyDimensionBoundsToForm() {
    const width = this.normalizeDimension(
      this.uploadLayoutForm.get("cheque_width").value,
      this.MAX_CHEQUE_WIDTH_CM
    );
    const height = this.normalizeDimension(
      this.uploadLayoutForm.get("cheque_height").value,
      this.MAX_CHEQUE_HEIGHT_CM
    );

    this.uploadLayoutForm.patchValue(
      {
        cheque_width: width || this.chequeDimensions.width,
        cheque_height: height || this.chequeDimensions.height,
      },
      { emitEvent: false }
    );

    if (width && height) {
      this.chequeDimensions = { width: width, height: height };
    }
  }

  private toFiniteNumber(value: any): number {
    const normalizedValue = this.normalizeDecimalString(value);
    const normalized = Number(normalizedValue);
    return isFinite(normalized) && normalized > 0 ? normalized : null;
  }

  private normalizeDecimalString(value: any): string {
    const englishDigits = String(value || "")
      .replace(/[\u0660-\u0669]/g, function (c) {
        return String(c.charCodeAt(0) - 0x0660);
      })
      .replace(/[\u06f0-\u06f9]/g, function (c) {
        return String(c.charCodeAt(0) - 0x06f0);
      })
      .replace(/,/g, ".");

    let output = "";
    let hasDot = false;
    for (let i = 0; i < englishDigits.length; i++) {
      const ch = englishDigits[i];
      if (ch >= "0" && ch <= "9") {
        output += ch;
        continue;
      }
      if (ch === "." && !hasDot) {
        output += ch;
        hasDot = true;
      }
    }
    return output;
  }

  private normalizeDimension(value: any, maxValue: number): number {
    const finiteValue = this.toFiniteNumber(value);
    if (!finiteValue) {
      return null;
    }
    return Math.min(finiteValue, maxValue);
  }

  private valueOrNoData(value: any, fallback = "No Data"): string {
    const normalized = String(value == null ? "" : value).trim();
    return normalized ? normalized : fallback;
  }

  private normalizeDateForInput(rawValue: any): string {
    const value = String(rawValue == null ? "" : rawValue).trim();
    if (!value) {
      return this.getTodayDateForInput();
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const slash = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
    if (slash) {
      const dd = slash[1].padStart(2, "0");
      const mm = slash[2].padStart(2, "0");
      const yyRaw = slash[3];
      const yyyy =
        yyRaw.length === 2 ? "20" + yyRaw : yyRaw.padStart(4, "0");
      return yyyy + "-" + mm + "-" + dd;
    }

    const dash = value.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})$/);
    if (dash) {
      const dd = dash[1].padStart(2, "0");
      const mm = dash[2].padStart(2, "0");
      const yyRaw = dash[3];
      const yyyy =
        yyRaw.length === 2 ? "20" + yyRaw : yyRaw.padStart(4, "0");
      return yyyy + "-" + mm + "-" + dd;
    }

    return this.getTodayDateForInput();
  }

  private patchBankSelectionFromTemplate(template: any) {
    const directBankId =
      (template && template.bank_id) ||
      (template && template.bank ? template.bank.id : null);

    if (directBankId) {
      this.uploadLayoutForm.patchValue({ bank_id: directBankId });
      return;
    }

    const legacyBankName = String(
      template && template.bank_name ? template.bank_name : ""
    ).trim();
    if (!legacyBankName || !Array.isArray(this.banks) || this.banks.length === 0) {
      return;
    }

    const normalize = function (value: string) {
      return value.replace(/\s+/g, " ").trim().toLowerCase();
    };

    const target = normalize(legacyBankName);
    const matchedBank = this.banks.find(function (bank: any) {
      return normalize(String(bank && bank.name ? bank.name : "")) === target;
    });

    if (matchedBank && matchedBank.id) {
      this.uploadLayoutForm.patchValue({ bank_id: matchedBank.id });
    }
  }

  buildTemplatePayload() {
    const check_date = document.getElementById("check_date");
    const check_amount = document.getElementById("check_amount");
    const check_to = document.getElementById("check_to");
    const check_amount_text = document.getElementById("check_amount_text");
    const formvalue = this.uploadLayoutForm.value;
    const formattedDate = this.getChequeDateDisplayValue();
    const dateDigitSpacing = this.normalizeDateDigitSpacing(
      this.dateDigitSpacingPx,
      this.DEFAULT_DATE_DIGIT_SPACING_PX
    );

    const payload: any = {
      bank_id: formvalue.bank_id,
      template_name: formvalue.template_name,
      Dimensions: {
        width: this.normalizeDimension(
          formvalue.cheque_width,
          this.MAX_CHEQUE_WIDTH_CM
        ),
        height: this.normalizeDimension(
          formvalue.cheque_height,
          this.MAX_CHEQUE_HEIGHT_CM
        ),
      },
      date: this.extendObject(this.getElementPositions(check_date), {
        value: this.date,
        raw_value: this.date,
        formatted_value: formattedDate,
        display_value: formattedDate,
        format: this.dateFormat,
        digit_spacing: dateDigitSpacing,
      }),
      beneficiary_name: this.extendObject(this.getElementPositions(check_to), {
        value: this.name,
      }),
      amount: this.extendObject(this.getElementPositions(check_amount), {
        value: this.amount,
      }),
      amount_text: this.extendObject(
        this.getElementPositions(check_amount_text),
        {
          value: this.amount_text,
          amountAfterFormat: this.amountAfterFormat,
        }
      ),
      linear: {
        value: this.liner_text,
        selected: true,
      },
    };

    if (formvalue.file && formvalue.file.value) {
      payload.bank = {
        file: formvalue.file.value,
        fileName: formvalue.file.filename,
      };
    }

    return payload;
  }

  private extendObject(base: any, extra: any) {
    const result = {};
    Object.keys(base || {}).forEach(function (key) {
      result[key] = base[key];
    });
    Object.keys(extra || {}).forEach(function (key) {
      result[key] = extra[key];
    });
    return result;
  }

  getElementPositions(element: HTMLElement) {
    if (!element) {
      return { top: "", left: "", bottom: "", right: "" };
    }
    const computedStyle = window.getComputedStyle(element);
    return {
      top: computedStyle.top,
      left: computedStyle.left,
      bottom: computedStyle.bottom,
      right: computedStyle.right,
    };
  }

  resetChequeViewFields() {
    this.name = "";
    this.date = this.getTodayDateForInput();
    this.amount_text = "";
    this.amountAfterFormat = "";
    this.liner_text = "";
    this.amount = "";
    this.dateFormat = this.DATE_FORMAT_STANDARD;
    this.dateDigitSpacingPx = this.DEFAULT_DATE_DIGIT_SPACING_PX;
  }

  private getTodayDateForInput(): string {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return yyyy + "-" + mm + "-" + dd;
  }

  getChequeDateDisplayValue(): string {
    if (this.dateFormat === this.DATE_FORMAT_SPACED_DDMMYYYY) {
      return this.formatDateForNbeModel3(this.date);
    }
    return String(this.date || "").trim();
  }

  getChequeDateStyle() {
    if (this.dateFormat !== this.DATE_FORMAT_SPACED_DDMMYYYY) {
      return {};
    }
    return {
      "letter-spacing.px": this.normalizeDateDigitSpacing(
        this.dateDigitSpacingPx,
        this.DEFAULT_DATE_DIGIT_SPACING_PX
      ),
    };
  }

  hasLinearText(): boolean {
    return String(this.liner_text || "").trim().length > 0;
  }

  onDateDigitSpacingInput() {
    const spacing = this.normalizeDateDigitSpacing(
      this.dateDigitSpacingPx,
      null
    );
    if (spacing !== null) {
      this.dateDigitSpacingPx = spacing;
    }
  }

  onDateDigitSpacingBlur() {
    this.dateDigitSpacingPx = this.normalizeDateDigitSpacing(
      this.dateDigitSpacingPx,
      this.DEFAULT_DATE_DIGIT_SPACING_PX
    );
  }

  private normalizeDateDigitSpacing(
    value: any,
    fallback: number
  ): number {
    const normalizedValue = this.normalizeDecimalString(value);
    if (!normalizedValue) {
      return fallback;
    }

    const spacing = Number(normalizedValue);
    if (!isFinite(spacing) || spacing < 0) {
      return fallback;
    }

    return spacing;
  }

  private formatDateForNbeModel3(inputDate: any): string {
    const value = String(inputDate || "").trim();
    if (!value) {
      return "";
    }

    let dd = "";
    let mm = "";
    let yyyy = "";

    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      yyyy = isoMatch[1];
      mm = isoMatch[2];
      dd = isoMatch[3];
    } else {
      const slashMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
      if (slashMatch) {
        dd = slashMatch[1].padStart(2, "0");
        mm = slashMatch[2].padStart(2, "0");
        yyyy =
          slashMatch[3].length === 2
            ? "20" + slashMatch[3]
            : slashMatch[3].padStart(4, "0");
      } else {
        const dashMatch = value.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})$/);
        if (dashMatch) {
          dd = dashMatch[1].padStart(2, "0");
          mm = dashMatch[2].padStart(2, "0");
          yyyy =
            dashMatch[3].length === 2
              ? "20" + dashMatch[3]
              : dashMatch[3].padStart(4, "0");
        }
      }
    }

    if (!dd || !mm || !yyyy) {
      return value;
    }

    return dd + mm + yyyy;
  }

  handleDrag(data?) {
    const checkTo = document.getElementById("check_to");
    const checkDate = document.getElementById("check_date");
    const checkAmount = document.getElementById("check_amount");
    const checkAmountText = document.getElementById("check_amount_text");

    if (checkTo) {
      this.dragElement(checkTo, "right");
    }
    if (checkDate) {
      this.dragElement(checkDate, "right");
    }
    if (checkAmount) {
      this.dragElement(checkAmount, "both");
    }
    if (checkAmountText) {
      this.dragElement(checkAmountText, "right");
    }

    if (data) {
      const checkDateEl = document.getElementById("check_date");
      if (checkDateEl && data.date) {
        checkDateEl.style.right = data.date.right;
        checkDateEl.style.left = data.date.left;
        checkDateEl.style.top = data.date.top;
        checkDateEl.style.bottom = data.date.bottom;
      }

      const checkToEl = document.getElementById("check_to");
      if (checkToEl && data.beneficiary_name) {
        const beneficiaryRight = String(
          data.beneficiary_name.right || ""
        ).trim();
        const beneficiaryLeft = String(
          data.beneficiary_name.left || ""
        ).trim();
        if (beneficiaryLeft && beneficiaryLeft !== "auto") {
          checkToEl.style.left = beneficiaryLeft;
          checkToEl.style.right = "auto";
        } else {
          checkToEl.style.right = beneficiaryRight || "2.7cm";
          checkToEl.style.left = "auto";
        }
        checkToEl.style.top = data.beneficiary_name.top;
        checkToEl.style.bottom = data.beneficiary_name.bottom;
      }

      const checkAmountTextEl = document.getElementById("check_amount_text");
      if (checkAmountTextEl && data.amount_text) {
        checkAmountTextEl.style.right = data.amount_text.right;
        checkAmountTextEl.style.left = data.amount_text.left;
        checkAmountTextEl.style.top = data.amount_text.top;
        checkAmountTextEl.style.bottom = data.amount_text.bottom;
      }

      const checkAmountEl = document.getElementById("check_amount");
      if (checkAmountEl && data.amount) {
        checkAmountEl.style.right = data.amount.right;
        checkAmountEl.style.left = data.amount.left;
        checkAmountEl.style.top = data.amount.top;
        checkAmountEl.style.bottom = data.amount.bottom;
      }
    } else {
      const checkDateEl = document.getElementById("check_date");
      if (checkDateEl && this.currentPositions.date) {
        checkDateEl.style.right = this.currentPositions.date.right;
        checkDateEl.style.left = this.currentPositions.date.left;
        checkDateEl.style.top = this.currentPositions.date.top;
        checkDateEl.style.maxWidth = this.currentPositions.date.width;
      }

      const checkToEl = document.getElementById("check_to");
      if (checkToEl && this.currentPositions.beneficiary_name) {
        checkToEl.style.right = this.currentPositions.beneficiary_name.right;
        checkToEl.style.left = this.currentPositions.beneficiary_name.left;
        checkToEl.style.top = this.currentPositions.beneficiary_name.top;
        checkToEl.style.bottom = this.currentPositions.beneficiary_name.bottom;
      }
    }
  }

  dragElement(elmnt, diir) {
    if (!elmnt || !elmnt.id) {
      return;
    }

    let pos1 = 0;
    let pos2 = 0;
    let pos3 = 0;
    let pos4 = 0;

    if (document.getElementById(elmnt.id + "header")) {
      document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else {
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
      if (diir === "right" || diir === "left" || diir === "both") {
        elmnt.style.right = "auto";
      }
    }

    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  formatMoney(x) {
    return x.toFixed(2);
  }

  getChequeFrameStyle() {
    return {
      "background-image": this.bank_image ? "url(" + this.bank_image + ")" : "",
      width: (this.chequeDimensions.width || 17.5) + "cm",
      height: (this.chequeDimensions.height || 8.2) + "cm",
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/print-cheque/print-cheque.component.ts